module.exports = __webpack_public_path__ + "static/img/bg-pt.5bbaca66.png";